var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flatpage)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"ten wide column"},[_c('h1',[_vm._v(_vm._s(_vm.flatpage.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.flatpage.content)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }